const LifeCycleService = {
    PUBLISHED:'PUBLISHED',
    UNPUBLISHED:'UNPUBLISHED',
    DRAFT:'DRAFT'
}
export { LifeCycleService }